import {useMemo} from 'react';
import {useWindowDimensions} from 'react-native';

export type Viewport = 'mobile' | 'pad' | 'desktop';

const PAD_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;

const getViewportFromWidth = (width: number): Viewport => {
  if (width >= DESKTOP_BREAKPOINT) {
    return 'desktop';
  }

  if (width >= PAD_BREAKPOINT) {
    return 'pad';
  }

  return 'mobile';
};

export const useViewport = (): Viewport => {
  const {width} = useWindowDimensions();

  return useMemo(() => getViewportFromWidth(width), [width]);
};
